import RecoverPasswordContainer from './RecoverPasswordContainer';

export default RecoverPasswordContainer;
